export default __webpack_public_path__ + "static/pca-5-8d0ad31c72cebc533810706b3214f2ec.webp";